import { HubExportPdfStore } from '../../stores/hub.calendar.store';
import { HubEvent } from './hub.event';
import { HubPlace } from './hub.place';

export class HubTour {
    public _id: String;
    public id: String;
    public title: String;
    public description: String;
    public attractions: Attraction[];
    public isActive: Boolean;
    public image: string;
    public travelTime: number;
    public distance: number;
    public stops: number;
    public order: number;

    // need to be refactored
    public cover: {
        source: string
    };
    public name: String;
    public isEventImageProcessed: Boolean;
    public defaultTravelMode: {
        mode: string;
        canChange: boolean;
    };
    public days: any[];
}

export class Attraction {
    public feedType: string;
    public id: string;
    public order: number;
    public status: string;
    public feedId: string;
    public event: HubEvent;
    public place: HubPlace;
    public item: HubEvent | HubPlace;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/models/hub/hub.tour.ts